import React, { Component } from 'react';
import styled from 'styled-components';

import Base, { arrToDate,
    CALENDAR_MONTHS,
    CALENDAR_WEEKS,
    getNextMonth,
    getPreviousMonth,
    getStartArray,
    THIS_MONTH,
    THIS_YEAR,
    WEEK_DAYS,
    zeroPad } from './calendarHelpers';
import {
    CalendarArrow,
    CalendarBody,
    CalendarDayLine,
    CalendarDayTitle,
    CalendarHeader,
    CalendarMonth,
    CalendarNumber,
} from './elements';

const ArrowLeft = styled(CalendarArrow)`
    &::before {
        transform: rotate(90deg);
        margin: 18px 0 0 25px;
    }
`;

const ArrowRight = styled(CalendarArrow)`
    &::before {
        transform: rotate(270deg);
        margin: 18px 25px 0 0;
    }
`;

class Calendar extends Component {

    state = {
        calendarMonth: `${CALENDAR_MONTHS[THIS_MONTH - 1]} ${THIS_YEAR}`,
        selectedDate: [],
        monthDays: [],
        month: THIS_MONTH,
        year: THIS_YEAR,
        minDate: null,
        maxDate: null,
    };

    componentDidMount() {
        this.init();
    }

    componentDidUpdate(prevProps) {
        const { nowDate } = this.props;
        if (prevProps.nowDate !== nowDate) {
            this.init();
        }
    }

    setCalendarMonth = () => {
        const { month, year } = this.state;
        this.setState({ calendarMonth: `${CALENDAR_MONTHS[month - 1]} ${year}` });
    }

    init = () => {
        const { nowDate, minDate, maxDate } = this.props;
        if (nowDate) {
            const startDate = getStartArray(nowDate);
            this.setState({ monthDays: Base(+startDate[1], +startDate[0]),
                selectedDate: startDate,
                month: +startDate[1],
                year: +startDate[0],
                minDate: minDate ? minDate : null,
                maxDate: maxDate ? maxDate : null }, () => this.setCalendarMonth());
        } else {
            this.setState({ monthDays: Base() });
        }
    }

    setPrevMonth = (e) => {
        const { month, year } = this.state;
        const date = getPreviousMonth(month, year);
        e.stopPropagation();
        this.setState({ monthDays: Base(+date.month, +date.year),
            month: +date.month,
            year: +date.year }, () => this.setCalendarMonth());
    }

    setNextMonth = (e) => {
        const { month, year } = this.state;
        const date = getNextMonth(month, year);
        e.stopPropagation();
        this.setState({ monthDays: Base(+date.month, +date.year),
            month: +date.month,
            year: +date.year }, () => this.setCalendarMonth());
    }

    selectNumber = (e, selectedDate, disabled) => {
        const { onChange } = this.props;
        if (disabled) {
            e.stopPropagation();
        } else {
            this.setState({ selectedDate });
            onChange([
                selectedDate[0],
                zeroPad(selectedDate[1], 2),
                zeroPad(selectedDate[2], 2),
            ].join('-'));
        }
    }

    /**
     * Проверим входит ли дата в доступный интервал. Если он не определен или дата входит в него, вернем true
     * @param item
     * @returns {boolean|*}
     */
    inInterval = (item) => {
        const { minDate, maxDate } = this.props;

        const itemTempVal = new Date(arrToDate(item));
        const itemDate = itemTempVal.getTime();

        const tempMinValue = minDate ? new Date(minDate) : null;
        const tempMaxValue = maxDate ? new Date(maxDate) : null;

        const minValue = tempMinValue ? tempMinValue.getTime() : null;
        const maxValue = tempMaxValue ? tempMaxValue.getTime() : null;

        if (!minDate && maxDate) {
            return (itemDate === maxValue) || (itemDate < maxValue);
        }
        if (!maxDate && minDate) {
            return (itemDate === minValue) || (itemDate > minValue);
        }
        if (maxDate && minDate) {
            return ((itemDate > minValue) || (itemDate === minValue)) && ((itemDate < maxValue) || (itemDate === maxValue));
        }

        return true;
    }

    getItems = (items, start, count, month, now) => {
        const { selectedDate } = this.state;
        const menuItems = [];
        const selectedDateStr = selectedDate.join('-');
        for (let i = start; i < start + count; i++) {
            const item = items[i];
            const disabled = month !== item[1] || !this.inInterval(item);
            const itemStr = item.join('-');
            menuItems.push(<CalendarNumber key={`item${i}`}
                onClick={(e) => this.selectNumber(e, item, disabled)}
                isDisabled={disabled}
                isNow={now[0] === item[0] && now[1] === item[1] && now[2] === item[2]}
                isSelected={selectedDateStr === itemStr}>{item[2]}</CalendarNumber>);
        }
        return menuItems;
    }

    render() {
        const { calendarMonth, monthDays, month } = this.state;
        const { showCalendar, $position } = this.props;
        const weekDays = WEEK_DAYS.map(item => <CalendarDayTitle key={item}>{item}</CalendarDayTitle>);
        const lines = [];

        if (monthDays.length > 0) {
            const viewMonth = month || THIS_MONTH;
            const nowDate = new Date();
            const now = [
                nowDate.getFullYear(),
                nowDate.getMonth() + 1,
                nowDate.getDate(),
            ];
            for (let i = 0; i < CALENDAR_WEEKS; i++) {
                lines.push(<CalendarDayLine key={`line${i}`}>{this.getItems(monthDays, i * 7, 7, viewMonth, now)}</CalendarDayLine>);
            }
        }

        return (
            <CalendarBody showCalendar={showCalendar} $position={$position}>
                <CalendarHeader>
                    <ArrowLeft onClick={(e) => this.setPrevMonth(e)} />
                    <CalendarMonth>{calendarMonth}</CalendarMonth>
                    <ArrowRight onClick={(e) => this.setNextMonth(e)} />
                </CalendarHeader>
                <CalendarDayLine>
                    {weekDays}
                </CalendarDayLine>
                <CalendarDayLine>
                    {lines}
                </CalendarDayLine>
            </CalendarBody>
        );
    }
}

export default Calendar;
